import React from 'react';
import classnames from 'classnames';
import { isString } from 'lodash';

export default class CardReference extends React.Component {

  static defaultProps = {
    borderRight: true,
    checked: false,
  };

  render() {
    const {
      onChange, checked, descricao, borderRight, disabled, borderNone, disabledCheckBox
    } = this.props;

    return (
      <div style={borderNone ? { border: 'none' } : null} className={`card ${classnames({ cardInput: borderRight })}`}>
        <div className="card-body">
          <div className="row">
            {disabledCheckBox ? (
              <></>
            ) : (
              <div className="col-1">
                <ul className="listCheckBox">
                  <li>
                    <label className="container-check-custom">
                      <input
                        type="checkbox"
                        aria-label=""
                        disabled={disabled}
                        onChange={onChange}
                        checked={checked}
                      />
                      <span className="checkmark" />
                    </label>
                  </li>
                </ul>
              </div>
            )}
            <div className="col-11">
              {isString(descricao) ? <p>{descricao}</p> : descricao}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
